import {normalizeText} from '../normalizeText'

// Helper para acceder a propiedades planas o anidadas
const getValueByPath = (obj, path) =>
  path.split('.').reduce((acc, key) => acc?.[key], obj);


// /**
//  *? @param {Array} users - array de usuarios
//  *? @param {Object} filters - valores de los inputs (watch())
//  *? @param {Object} filterDefinition - reglas de búsqueda
//  */

export const applyFilters = (
  users = [],
  filters = {},
  filterDefinition = {}
) => {
  if (!Array.isArray(users)) return [];

  return users.filter(user =>
    Object.entries(filters).every(([filterKey, value]) => {

      // Input vacío → no filtra
      if (value === "" || value === "0" || value == null) return true;

      const definition = filterDefinition?.[filterKey];
      if (!definition?.fields) return true;

      const search = normalizeText(value);

      return definition.fields.some(field => {
        const fieldValue = getValueByPath(user, field);
        return normalizeText(fieldValue).includes(search);
      });
    })
  );
};
